import { Component } from "@angular/core";
import { ModalService } from "../../services/modal/modal.service";

export type DialogResult = "confirm" | "cancel";
interface DialogAction {
  label: string;
  action: () => DialogResult;
}
export type DialogVariant = "info" | "success" | "error";

export interface DialogData {
  title?: string;
  message: string;
  actions?: DialogAction[];
  /**
   * Visual variant. Defaults to "info" (blue). "success" renders green
   * accents; "error" renders red. Does not affect behavior.
   */
  variant?: DialogVariant;
}

@Component({
  selector: "app-dialog",
  standalone: true,
  imports: [],
  templateUrl: "./dialog.component.html",
  styleUrl: "./dialog.component.scss",
})
export class DialogComponent {
  isOpen = false;
  dialogData!: DialogData;

  constructor(private modalService: ModalService) {
    modalService.registerDialog(this);
  }
}
